/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { HttpResponse, delay } from "msw";

// Value for `company-gmt-offset` (minutes diff from GMT)
// Set it to `new Date().getTimezoneOffset() + ""` for same as client
// Example : -60 means UTC + 1hr
const mock_company_gmt_offset = "-60";
/**
 * A custom response helper for MSW v2, to reuse
 * standard response configurations according to our needs.
 * See [MSW v2 docs](https://mswjs.io/docs/api/http-response).
 *
 * @param {Object}  data           - JSON data to return
 * @param {number}  status         - HTTP status code (default: 200)
 * @param {Object}  extraHeaders   - Additional headers to include
 * @returns {HttpResponse}         - MSW v2 response object
 */
export async function customResponse(data, status = 200, extraHeaders = {}) {
  const mock_response_now = new Date();

  // Add delay for testing latency
  await delay(700);

  return HttpResponse.json(data, {
    status,
    headers: {
      /**
       * Company's current time offset from GMT / UTC (adjusted for DST), according to
       * [getTimezoneOffset](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset)
       */
      "company-gmt-offset": mock_company_gmt_offset,
      /** custom header: Unix timestamp (in seconds) */
      "utc-ts": Math.round(mock_response_now.getTime() / 1000).toString(),
      /**
       * Company's time zone, using Oslo for testing - see
       * [current time in Oslo](https://www.zeitverschiebung.net/en/timezone/europe--oslo)
       */
      "company-tz": "Europe/Oslo",
      Date: mock_response_now.toUTCString(), // Standard response header
      ...extraHeaders
    }
  });
}
